import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs/index';
import {Action, Store} from '@ngrx/store';
import {DataService} from '../price-discovery/services/dataService/data.service';
import {AppState} from '../reducers';
import * as PriceDiscoveryActionTypes from '../actions/PriceDiscoveryActions';
import {map, mergeMap} from 'rxjs';
import {IPriceDiscoveryModel} from '../models/IPriceDiscoveryModel';


@Injectable()
export class PriceDiscoveryEffects {
  update$: Observable<Action> = createEffect(() => this.action$.pipe(
    ofType(PriceDiscoveryActionTypes.UpdateCropsAction),
    mergeMap(action =>
      this.dataService.getCommodities(action.year.year, action.state.federalStateNumber)
        .pipe(
          map((priceDiscovery: Array<IPriceDiscoveryModel>) => PriceDiscoveryActionTypes.PriceDiscoveryReceived({prices: priceDiscovery})),
        )
    )
  ));

  constructor(private dataService: DataService, private action$: Actions, private store: Store<AppState>) {
  }
}
